// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-group[data-v-1d08e046]{margin-bottom:0!important}.form-group:first-of-type label[data-v-1d08e046]{margin-top:0!important}.form-group .optional[data-v-1d08e046]{font-size:12px!important;font-weight:500!important;color:#9eafb5!important}", ""]);
// Exports
module.exports = exports;
